import request from '@/utils/request';
export const fileTransferHeaders = {};
export const defaultCashDiscountsData = {
  id: 0,
  enabled: true,
  startDuration: undefined,
  endDuration: undefined,
  discount: undefined
};
export const getCashDiscounts = params => request({
  url: '/cash-discounts',
  method: 'get',
  params
});
export const getCashDiscountById = id => request({
  url: `/cash-discounts/${id}`,
  method: 'get'
});
export const updateCashDiscount = (id, data) => request({
  url: `/cash-discounts/${id}`,
  method: 'patch',
  data
});
export const deleteCashDisocunt = id => request({
  url: `/cash-discounts/${id}`,
  method: 'delete'
});
export const createCashDiscount = data => request({
  url: '/cash-discounts/',
  method: 'post',
  data
});